<template>
  <v-card>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.push('/organisation/bailleurs')"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Etapes de {{ $route.params.activite.ll_parcours }} (
      {{ $route.params.activite.abbr_bailleur }} -
      {{ $route.params.activite.ll_programme }} )

      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card-text>
      <v-btn
        color="blue-grey"
        class="ma-2 white--text"
        @click="dialogEtape = !dialogEtape"
        rounded
      >
        <v-icon left dark> mdi-plus-circle-outline </v-icon>
        Nouvelle étape
      </v-btn>
      <!--   <v-btn
        color="blue"
        class="ma-2 white--text"
        @click="getEtapeData($route.params.activite.id)"
        rounded
      >
        <v-icon left dark> mdi-reload </v-icon>
        Recharger
      </v-btn> -->
      <v-dialog v-model="dialogEtape" persistent max-width="600px">
        <v-card>
          <v-card-title>Etape</v-card-title>
          <v-card-text>
            <v-form ref="formEtape" v-model="valid" lazy-validation>
              <v-text-field
                v-model="ll_etape"
                label="Etape"
                prepend-icon="post_add"
                :rules="nameRules"
                required
              ></v-text-field>
              <v-text-field
                ref="rang"
                v-model="rang"
                label="Rang"
                prepend-icon="post_add"
                disabled
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded class="primary" @click="closeDialog()" text
              >Annuler</v-btn
            >
            <v-btn rounded class="primary" @click="updateCreateEtape()"
              >Sauvegarder</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Rang
              </th>
              <th class="text-left">
                Détails
              </th>

              <th class="text-left">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in etapes" :key="index">
              <td>{{ item.rang }}</td>
              <td>{{ item.ll_etape }}</td>

              <td>
                <v-btn
                  outlined
                  x-small
                  fab
                  dark
                  class="warning mr-2"
                  @click="openDialogEtape(item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  @click="deleteEtape(item)"
                  outlined
                  x-small
                  fab
                  dark
                  class="danger mr-2"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn
                  @click="detailsEtapes(item)"
                  outlined
                  x-small
                  fab
                  dark
                  class="success"
                >
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    DetailsEtape: require("@/components/organisation/detailsEtape").default,
  },
  created() {
    if (!this.$route.params.activite) {
      console.log("pas de paramètres", this.$route.params.bailleur);
      this.$router.go(-1);
    }
    this.getEtapeData(this.$route.params.activite.id);
  },
  data() {
    return {
      idEtape: null,
      ll_etape: "",
      etapes: [],
      dialogEtape: false,
      dialogDeleteEtape: false,
      rang: "",
      valid: true,
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 2) || "Au moins deux caractères",
      ],
    };
  },
  methods: {
    updateCreateEtape() {
      const parcours = this.$route.params.activite;
      this.rang = this.etapes.length + 1;
      let self = this;
      if (this.$refs.formEtape.validate()) {
        if (!this.idEtape) {
          console.log("Nouvelle étape");
          let uuid = "0000000000000000aaaaaEtape-" + this.$uuid.v4();
          const newEtape = {
            ll_etape: this.ll_etape,
            rang: this.rang,
            parcours_id_parcours: parcours.id,
            abbr_parcours: parcours.abbr_parcours,
            description_parcours: parcours.description_parcours,
            ll_parcours: parcours.ll_parcours,
            ll_programme: parcours.ll_programme,
            ll_theme: parcours.ll_theme,
            programmes_id_programme: parcours.programmes_id_programme,
            themes_id_theme: parcours.themes_id_theme,
          };

          // Add a new document in collection "activites"
          this.$firebase
            .firestore()
            .collection("etapes")
            .doc(uuid)
            .set(newEtape)
            .then(function () {
              console.log("Etape successfully written!", newEtape);
              self.idEtape = null;
              self.getEtapeData(self.$route.params.activite.id);
            })
            .catch(function (error) {
              console.error("Error writing Etape: ", error);
            });
          self.idEtape = null;
        } else {
          console.log("Edition étape");

          const updatedEtape = {
            ll_etape: this.ll_etape,
            rang: this.$refs.rang.value,
            parcours_id_parcours: parcours.id,
            abbr_parcours: parcours.abbr_parcours,
            description_parcours: parcours.description_parcours,
            ll_parcours: parcours.ll_parcours,
            ll_programme: parcours.ll_programme,
            ll_theme: parcours.ll_theme,
            programmes_id_programme: parcours.programmes_id_programme,
            themes_id_theme: parcours.themes_id_theme,
          };
          console.log("Etape id : ", self.idEtape);
          console.log("Etape updated : ", updatedEtape);
          var etapeRef = this.$firebase
            .firestore()
            .collection("etapes")
            .doc(self.idEtape);
          etapeRef.set(updatedEtape, { merge: true });
          self.idActivite = null;
          self.getEtapeData(self.$route.params.activite.id);
        }
        this.dialogEtape = false;
      }

      this.ll_etape = "";
      this.rang = this.etapes.length + 1;
    },

    deleteEtape(etape) {
      let self = this;
      this.$confirm("Voulez vous effacer cette étape?").then((res) => {
        if (res) {
          //console.log(etape)
          this.$firebase
            .firestore()
            .collection("etapes")
            .doc(etape.id)
            .delete()
            .then(() => {
              console.log("Etape " + etape.ll_etape + " successfully deleted!");
              self.getEtapeData(self.$route.params.activite.id);
            })
            .catch((error) => {
              console.error("Error removing étape: ", error);
              self.getEtapeData(self.$route.params.activite.id);
            });
        }
      });
    },

    detailsEtapes(etape) {
      var self = this;
      this.$router.push({
        name: "organisation-detailsEtapes-id",
        params: { etape: etape, activite: self.$route.params },
      });
    },
    openDialogEtape(etape) {
      this.idEtape = etape.id;
      this.dialogEtape = true;
      // this.abbr_parcours = activite.abbr_parcours;
      // this.description_parcours = activite.description_parcours;
      this.ll_etape = etape.ll_etape;
      this.rang = etape.rang;
    },
    closeDialog() {
      this.dialogEtape = false;
      this.dialogDeleteEtape = false;
      //this.$refs.formEtape.reset();
      this.ll_etape = "";
      this.rang = this.etapes.length + 1;
    },
    getEtapeData(activiteId) {
      this.etapes = [];
      let self = this;
      this.$firebase
        .firestore()
        .collection("etapes")
        .where("parcours_id_parcours", "==", activiteId.toString())
        .orderBy("rang")
        .get()
        .then((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              //console.log("New Doc: ", change.doc.data());
              //self.etapes=[];
              self.etapes.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
              self.rang = self.etapes.length + 1;
            }
            if (change.type === "modified") {
              let obj = self.etapes.find(
                (search) => search.id === change.doc.id
              );

              //bailleurs
              /*  obj.name = change.doc.data().abbr_bailleur;
                            obj.title = change.doc.data().ll_bailleur;
                            obj.ll_bailleur = change.doc.data().ll_bailleur;
                            obj.abbr_bailleur = change.doc.data().abbr_bailleur; */
            }
            if (change.type === "removed") {
              /*   console.log("Removed : ", change.doc.data());
                            let obj = elems.find((search) => search.id === change.doc.id);
                            const index = elems.indexOf(obj);
                            Vue.delete(elems, index); */
              //deleteProjetsDeBailleurs
            }
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
